"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tomTomBatchResponseSchema = exports.tomTomBatchItemSchema = exports.tomTomRoutingResponseSchema = exports.tomTomRouteSchema = exports.tomTomProgressSchema = exports.tomTomRouteLegSchema = exports.tomTomRouteSummarySchema = exports.tomTomPointSchema = void 0;
const zod_1 = require("zod");
// TomTom Routing API v1 — only the fields the routing flow reads. Unknown keys are stripped.
// https://docs.tomtom.com/routing-api/documentation/tomtom-maps/calculate-route
// Schemas are left to inference for the same reason as in bosch.ts (strictNullChecks:false
// consumers would otherwise see every field as optional).
exports.tomTomPointSchema = zod_1.z.object({
    latitude: zod_1.z.number(),
    longitude: zod_1.z.number(),
});
exports.tomTomRouteSummarySchema = zod_1.z.object({
    lengthInMeters: zod_1.z.number(),
    travelTimeInSeconds: zod_1.z.number(),
});
/** `points` is absent under `routeRepresentation=summaryOnly`; the leg summary stays. */
exports.tomTomRouteLegSchema = zod_1.z.object({
    summary: exports.tomTomRouteSummarySchema,
    points: zod_1.z.array(exports.tomTomPointSchema).optional(),
});
/** Cumulative travel time/distance at a route point (`extendedRouteRepresentation`). */
exports.tomTomProgressSchema = zod_1.z.object({
    pointIndex: zod_1.z.number().optional(),
    distanceInMeters: zod_1.z.number().optional(),
    travelTimeInSeconds: zod_1.z.number().optional(),
});
exports.tomTomRouteSchema = zod_1.z.object({
    summary: exports.tomTomRouteSummarySchema,
    legs: zod_1.z.array(exports.tomTomRouteLegSchema).optional(),
    progress: zod_1.z.array(exports.tomTomProgressSchema).optional(),
});
/** `routes` is absent when TomTom finds no route. */
exports.tomTomRoutingResponseSchema = zod_1.z.object({
    routes: zod_1.z.array(exports.tomTomRouteSchema).optional(),
});
/**
 * One item of a synchronous batch response. A failed item carries its reason in
 * `response.error.description`, with the item's own `statusCode`, inside an HTTP 200 batch.
 * https://docs.tomtom.com/routing-api/documentation/tomtom-maps/batch-routing/synchronous-batch
 */
exports.tomTomBatchItemSchema = zod_1.z.object({
    statusCode: zod_1.z.number(),
    response: zod_1.z
        .object({
        routes: zod_1.z.array(exports.tomTomRouteSchema).optional(),
        error: zod_1.z.object({ description: zod_1.z.string() }).optional(),
    })
        .optional(),
});
exports.tomTomBatchResponseSchema = zod_1.z.object({
    batchItems: zod_1.z.array(exports.tomTomBatchItemSchema),
});
//# sourceMappingURL=tomtomRouting.js.map